import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import type { Deal } from '../../types';
const SOL_COLORS = ['#fa0f00', '#2c2c2c', '#a78bfa', '#34d399', '#d4a017', '#60a5fa', '#f87171', '#10b981', '#f59e0b'];
const TOP = 8;
function bucketSolution(products: string): string {
  if (!products || products.trim() === '') return 'Unknown';
  const parts = products.split(',').map(p => p.trim()).filter(Boolean);
  const normed = [...new Set(parts.map(p => p.toUpperCase().startsWith('AEM') ? 'AEM' : p.trim()))];
  return normed.length === 1 ? normed[0] : 'Multi-Solution';
}
interface Props {
  deals: Deal[];
}
export function OfferingChart({
  deals
}: Props) {
  const solMap: Record<string, number> = {};
  deals.forEach(d => {
    const sol = bucketSolution(d.products || '');
    solMap[sol] = (solMap[sol] || 0) + 1;
  });
  const solSorted = Object.entries(solMap).sort((a, b) => b[1] - a[1]);
  let labels: string[], vals: number[];
  if (solSorted.length > TOP) {
    const top = solSorted.slice(0, TOP);
    const othersCount = solSorted.slice(TOP).reduce((s, [, v]) => s + v, 0);
    labels = [...top.map(([l]) => l), 'Others'];
    vals = [...top.map(([, v]) => v), othersCount];
  } else {
    labels = solSorted.map(([l]) => l);
    vals = solSorted.map(([, v]) => v);
  }
  const data = labels.map((name, i) => ({
    name,
    value: vals[i]
  }));
  return <ResponsiveContainer width="100%" height={170} data-id="element-24">
      <PieChart data-id="element-25">
        <Pie data={data} cx="40%" cy="50%" innerRadius={45} outerRadius={70} dataKey="value" strokeWidth={2} stroke="#fff" data-id="element-26">
          {data.map((_, i) => <Cell key={i} fill={SOL_COLORS[i % SOL_COLORS.length]} data-id="element-27" />)}
        </Pie>
        <Tooltip contentStyle={{
        fontSize: 11,
        border: '1px solid #e8eaf0',
        borderRadius: 6
      }} formatter={(v: number) => [v, 'Deals']} data-id="element-28" />
        <Legend layout="vertical" align="right" verticalAlign="middle" wrapperStyle={{
        fontSize: 9,
        color: '#667085',
        paddingLeft: 8
      }} iconSize={10} iconType="square" data-id="element-29" />
      </PieChart>
    </ResponsiveContainer>;
}